
function setBurgerInfoHeight() {
    const scaleWidthMB = 768;
    const navHeight = 80;
    const scale = window.innerWidth / scaleWidthMB;
    const height = window.innerHeight / scale;
    $('#Navigation .burger-info').css('height', height + 'px');
    $('#Navigation .list-navs').css('max-height', (height - navHeight) + 'px');
}

window.addEventListener("load", function () {
    setBurgerInfoHeight();
    window.addEventListener('resize', setBurgerInfoHeight);

    $('#Navigation .list-navs a').on('click', function () {
        if (!$(this).siblings('.sub-navs').length) {
            $('#Navigation').removeClass('active');
        }
    });

    $('#Navigation .list-navs > li').on('click', function () {
        $('#Navigation .list-navs > li').removeClass('active');
        $(this).addClass('active');
    });

    const sectionNavMap = {
        'cfl-ms-25-header': 0,
        'cfl-ms-25-news': 1,
        'cfl-ms-25-characters': 2,
        'cfl-ms-25-gallery': 3,
    };

    const $navLis = $('#Navigation .list-navs > li');

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                const idx = sectionNavMap[entry.target.id];
                if (idx !== undefined) {
                    $navLis.removeClass('active');
                    $navLis.eq(idx).addClass('active');
                }
            }
        });
    }, { threshold: 0.3 });

    Object.keys(sectionNavMap).forEach(function (id) {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
    });

    const $language = $('#Navigation .right-group .language');
    const $listNavs = $('#Navigation .list-navs');
    const $rightGroup = $('#Navigation .right-group');
    const $languageLi = $('<li class="language-li"></li>');
    const mq = window.matchMedia('(max-width: 768px) and (orientation: portrait)');

    function repositionLanguage() {
        if (mq.matches) {
            if (!$listNavs.find('.language-li').length) {
                $languageLi.append($language);
                $listNavs.append($languageLi);
            }
        } else {
            if (!$rightGroup.find('.language').length) {
                $rightGroup.prepend($language);
            }
        }
    }

    repositionLanguage();
    mq.addEventListener('change', repositionLanguage);

    $('#Navigation .btn-language').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.language').find('.sub-language').toggleClass('active');
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('#Navigation .language').length) {
            $('#Navigation .sub-language').removeClass('active');
        }
    });

    // Override language switch: khi data-go-to-main=true, redirect tới /{lang}/official
    // dùng capture phase để chặn trước library handler
    const subLang = document.querySelector('#Navigation .sub-language');
    if (subLang) {
        subLang.addEventListener('click', function (e) {
            const region = e.target.closest('.region[data-go-to-main="true"]');
            if (!region) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            const newLang = region.getAttribute('data-region');
            const date = new Date();
            date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
            document.cookie = `language=${newLang};expires=${date.toUTCString()};path=/`;
            document.location.href = `/${newLang}/official`;
        }, true);
    }
    // const $item = $('#Navigation .list-navs > li').eq(2);
    // console.log($item);
    // $item.on('click', function (e) {
    //     e.preventDefault();
       
    //     $('#libraryMainsite-t-float_left .list-btns a').last().trigger('click');
    // }); 
    
        let audio = null;
        $('.MS__sprite-btn-music').on('click', function (e) {
            e.preventDefault();

            const $btn = $(this);
            const audioSrc = $('#Navigation').attr('data-audio');
            if (!audioSrc) return;

            // Khởi tạo audio nếu chưa có
            if (!audio) {
                audio = document.createElement('audio');
                audio.id = 'dynamic-audio';
                audio.src = audioSrc;
                document.body.appendChild(audio);

                // Gán onended đúng 1 lần duy nhất
                audio.onended = function () {
                    $btn.removeClass('active');
                };
            }

            // So sánh src bằng getAttribute (tránh reload liên tục)
            const currentSrc = audio.getAttribute('src');
            if (currentSrc !== audioSrc) {
                audio.pause();
                audio.src = audioSrc;
                audio.load();
            }

            // Toggle phát / tạm dừng
            if (audio.paused || audio.ended) {
                audio.play().then(() => {
                    $btn.addClass('active');
                }).catch((err) => {
                    console.warn('Audio play failed:', err);
                });
            } else {
                audio.pause();
                $btn.removeClass('active');
            }
        });

        $(window).one('click keydown', function (e) {
            
                if (!$(e.target).closest('.btn-music').length) {
                    $('#Navigation .MS__sprite-btn-music').trigger('click');
                }
            
            

        });
    



});

